module.exports = __webpack_public_path__ + "img/gelb1.4f58456f.png";